"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chevronDownSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-down-small"));

var _AccordionItemHeader = _interopRequireDefault(require("./AccordionItemHeader"));

var _AccordionContext = _interopRequireDefault(require("./AccordionContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AccordionItem = (0, _react.forwardRef)((props, ref) => {
  const {
    id,
    prefix,
    className,
    title,
    disabled,
    children,
    onHeadingClick,
    onHeadingClicked,
    small,
    subtitle,
    caption,
    open,
    index,
    ...other
  } = props;
  const ctx = (0, _react.useContext)(_AccordionContext.default);
  const [isOpen, setOpen] = (0, _react.useState)(open);
  const labelRef = (0, _react.useRef)();
  const classes = (0, _classnames.default)(isOpen && !disabled && `${prefix}accordion__item--active`, small && `${prefix}accordion__item--small`, `${prefix}accordion__item`, className);
  const iconState = (0, _classnames.default)(isOpen && !disabled && 'rotate-180');
  (0, _react.useEffect)(() => {
    if (index === ctx.selected && labelRef.current) {
      labelRef.current.focus();
    }
  }, [index, ctx.selected]);
  (0, _react.useEffect)(() => {
    let copy = ctx.disabledItems;
    copy[index] = disabled;
    ctx.setDisabledItems(copy);
  }, [disabled]);
  (0, _react.useEffect)(() => {
    setOpen(ctx.openedItems[id]);
  }, [ctx.openedItems]);

  const handleHeadingClick = evt => {
    ctx.onHeadingClick(id, ctx.openedItems, ctx.setOpenedItems);

    if (onHeadingClicked) {
      onHeadingClicked(evt);
    }
  };

  const handleKeyDown = evt => {
    if (['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(evt.key)) {
      evt.preventDefault();
      ctx.onNavigation(ctx.setSelected, ctx.disabledItems, evt.which, ctx.focusRef);
    }
  };

  return _react.default.createElement("li", _extends({
    className: classes,
    onKeyDown: handleKeyDown,
    id: id,
    ref: ref
  }, other), _react.default.createElement("div", {
    role: "heading",
    "aria-level": "2"
  }, _react.default.createElement(_AccordionItemHeader.default, {
    className: `${prefix}accordion__heading`,
    prefix: prefix,
    onClick: handleHeadingClick,
    "aria-controls": `SEC_${id}`,
    disabled: disabled,
    title: title,
    small: small,
    subtitle: caption || (!isOpen ? subtitle : ''),
    ssrIcon: _chevronDownSmall.default,
    iconState: iconState,
    "aria-expanded": isOpen ? true : false,
    onFocus: () => {
      ctx.focusRef.current = index;
    },
    onBlur: () => {
      ctx.focusRef.current = null;
    },
    ref: labelRef
  })), _react.default.createElement("div", {
    id: `SEC_${id}`,
    className: `${prefix}accordion__content`,
    "aria-labelledby": id,
    role: "region"
  }, children));
});
AccordionItem.defaultProps = {
  title: 'Title',
  open: false,
  onHeadingClick: () => {},
  prefix: ''
};
var _default = AccordionItem;
exports.default = _default;